<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Reports</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
      <mat-nav-list role="list">
          <a mat-list-item routerLink="report">Some report</a>
      </mat-nav-list>
  </mat-card-content>
</mat-card>
